namespace GeniuzPOS.Administration {
    export interface PsConfigTypeForm {
        ConfigTypeId: Serenity.StringEditor;
        ConfigTypeName: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        IsActive: Serenity.BooleanEditor;
    }

    export class PsConfigTypeForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.PsConfigType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsConfigTypeForm.init)  {
                PsConfigTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;

                Q.initFormType(PsConfigTypeForm, [
                    'ConfigTypeId', w0,
                    'ConfigTypeName', w0,
                    'Description', w0,
                    'IsActive', w1
                ]);
            }
        }
    }
}
